import React, { useState, useRef, useEffect } from "react";
import ReviewCard from "../../molecules/ReviewCard/ReviewCard";

import princareImage from "../../../static/princare_logo.png";
import medosanImage from "../../../static/medosan_logo2.png";
import pediatriamodraImage from "../../../static/pediatriamodra_logo.png";

const Reviews: React.FC = () => {
  const reviews = [
    {
      rating: 5,
      title: "PRINCARE s.r.o.",
      body: "Vďaka DoktorUI mám dekurzy hotové rýchlejšie a prehľadnejšie. Upozorní ma na dôležité položky ale aj detaily, ktoré treba zaznamenať, takže mám istotu, že dokumentácia je kompletná a kvalitná. Značne menej času trávim pri počítači a viac pri pacientovi.",
      reviewerName: "MUDr. Jessica Džupová",
      reviewerImage: princareImage,
      date: "11.7.2025",
    },
    {
      rating: 5,
      title: "MEDOSAN s.r.o.",
      body: "Pracujem 25 rokov na ambulancii všeobecného lekára v Revúcej a páči sa mi táto myšlienka, lebo to naozaj skráti čas mojej práce a aj práce mojej sestričky.",
      reviewerName: "MUDr. Iveta Mráziková",
      reviewerImage: medosanImage,
      date: "18.11.2025",
    },
    {
      rating: 5,
      title: "Pediatria Modra, spol. s r.o.",
      body: "Keď si porovnám text v zázname v minulosti, stále som niečo prepisoval...\nDnes nechám v dokumentácii kvalitný záznam, ktorý ma po právnickej stránke chráni a už ma aj podržal. Často príde pacient so zložitou dif.diagnostikou, keď už som unavený... ale ja na nič nezabudnem.\nPracujem s DoktorUI denne a ak si chcem niečo zmeniť, upravím si to okamžite sám.\nPráce viac a viac, prečo si to neuľahčiť?",
      reviewerName: "MUDr. Richard Džupa",
      reviewerImage: pediatriamodraImage,
      date: "1.9.2025",
    },
  ];

  const [activeSlide, setActiveSlide] = useState(1);
  const cardsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (cardsRef.current && window.innerWidth <= 1243) {
        const container = cardsRef.current;
        const scrollLeft = container.scrollLeft;
        const scrollWidth = container.scrollWidth;
        const clientWidth = container.clientWidth;

        const maxScroll = scrollWidth - clientWidth;

        if (maxScroll <= 0) {
          setActiveSlide(0);
          return;
        }

        const scrollPercentage = scrollLeft / maxScroll;

        let newActiveSlide = 0;
        if (scrollPercentage > 0.66) {
          newActiveSlide = 2;
        } else if (scrollPercentage > 0.33) {
          newActiveSlide = 1;
        } else {
          newActiveSlide = 0;
        }

        setActiveSlide(newActiveSlide);
      }
    };

    const cardsElement = cardsRef.current;
    if (cardsElement) {
      cardsElement.addEventListener("scroll", handleScroll, { passive: true });

      if (window.innerWidth <= 1243) {
        setTimeout(() => {
          scrollToSlide(1);
        }, 100);
      }
    }

    return () => {
      if (cardsElement) {
        cardsElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const scrollToSlide = (index: number) => {
    if (cardsRef.current && window.innerWidth <= 1243) {
      const container = cardsRef.current;
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;
      const maxScroll = scrollWidth - clientWidth;

      let targetScroll = 0;
      if (index === 1) {
        targetScroll = maxScroll * 0.5;
      } else if (index === 2) {
        targetScroll = maxScroll;
      }

      container.scrollTo({
        left: targetScroll,
        behavior: "smooth",
      });
      setActiveSlide(index);
    }
  };

  return (
    <div className="dui-reviews" id="reviews">
      <div className="dui-reviews-container">
        <h2 className="dui-reviews-heading">
          Čo hovoria naši zákazníci
        </h2>
        <div className="dui-reviews-cards" ref={cardsRef}>
          {reviews.map((review, index) => (
            <ReviewCard
              key={index}
              rating={review.rating}
              title={review.title}
              body={review.body}
              reviewerName={review.reviewerName}
              reviewerImage={review.reviewerImage}
              date={review.date}
            />
          ))}
        </div>

        <ul className="carousel-indicators">
          {reviews.map((_, index) => (
            <li
              key={index}
              className={index === activeSlide ? "active" : ""}
              onClick={() => scrollToSlide(index)}
            />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Reviews;

